import _ from 'lodash';
import React, { useContext, useEffect, useState } from 'react';
import { Label, Menu } from 'semantic-ui-react';
import { EventInfoContext } from '../../../cnr/contexts/EventInfoContext';
import { filterHelpers } from '../../../common/filtering';
import DragDropper, { dragDropperTypes } from '../../../dragNDrops/DragDropper';
import { gEnums } from '../../../enums/globalEnums';
import { FormItemContext } from '../FormItem';
import Checker from './Checker';
import Wrapper, { wrapperTypes } from 'global/wrappers/Wrapper';

const _allowedSortProps = ['appUserProfileSettings', 'appUserPersonalPages', 'navigationItems', 'sideMenuItems']

/**
 * 
 * @param {object} props (itemProp, menuList, fip)
 * @returns A Menu-like select
 */
const MenuItemsSelect = (props) => {

  // menuList is being passed int
  const { menuList } = props

  // formItemContext
  const formItemContext = useContext(FormItemContext)
  const { formItem_state } = formItemContext ?? {}
  const { fip, itemProp } = formItem_state ?? {}

  const _fip = props.fip || fip || {}
  const _itemProp = props.itemProp || itemProp || {}

  const { onChange, propname, value: fip_value } = _fip ?? {}
  const { data } = _itemProp ?? {}
  const { formItemType, staticView } = data ?? {}

  const allowSort = _allowedSortProps.includes(propname)

  let useCounter = false

  switch (formItemType) {
    case gEnums.formItemTypes.menuItemSelectFullCount:
      useCounter = true
      break;
    default:
    // nothing
  }

  if (menuList && fip_value) {
    if (fip_value && _.isArray(fip_value)) {
      fip_value.forEach((fipv, index) => {
        if (_.isObject(fipv)) {
          const x = filterHelpers.find(menuList, 'value', fipv.value)
          if (x) {
            x.selected = true
            x.position = index
          }
        } else {
          const x = filterHelpers.find(menuList, 'value', fipv)
          if (x) {
            x.selected = true
            x.position = index
          }
        }
      })
    }
  }

  // eventInfoContext
  const eventInfoContext = useContext(EventInfoContext)
  const { eventInfo_state } = eventInfoContext ?? {}
  const { staticViews } = eventInfo_state ?? {}

  // local state
  const [selectedList, setSelectedList] = useState()
  const [selectedStaticView] = useState(staticViews && staticView && staticViews[staticView] ? staticViews[staticView] : null)
  const [toggleSelectOn, setToggleSelectOn] = useState(false)
  const [menuElements, setMenuElements] = useState()

  const valueCount = fip_value ? Object.keys(fip_value).length : 0

  useEffect(() => {
    const _menuList = _.sortBy(menuList, ['position', 'text'])
    setSelectedList(_menuList)
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [menuList]);

  useEffect(() => {
    const mes = menuItems(selectedList)
    setMenuElements(mes)

    switch (formItemType) {
      case gEnums.formItemTypes.menuItemSelectFull:
        const svls = _.filter(selectedList, i => i.selected === true);
        updatePropValue(svls)
        break;
      default:
        const siss = getSelectedKeys(selectedList, formItemType)
        updatePropValue(siss)
        break;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [selectedList]);

  const updatePropValue = (sis) => {
    const data = { propname }
    if (selectedStaticView) {
      // convert to full object
      const sisf = {}
      if (_.isArray(sis)) {
        sis.forEach(si => {
          const { key, value } = si
          const x = filterHelpers.find(selectedStaticView, 'key', value) // _.find(selectedStaticView, { 'key': value })
          if (x) {
            sisf[key] = x
          }
        })
      } else {
        Object.keys(sis).forEach(key => {
          if (selectedStaticView[sis[key].value]) {
            sisf[sis[key].value] = selectedStaticView[sis[key].value]
          }
        })
      }
      onChange(null, data, null, sisf)
    } else {
      onChange(null, data, null, sis)
    }
  }

  const getSelectedKeys = (sis) => {
    return _.chain(sis)
      .filter({ selected: true })
      .map('value')
      .value();
  };

  // handles after sort
  const handleSorted = (sortedGroups) => {
    _.forEach(sortedGroups, (group, key) => {
      const sortedItems = _.sortBy(group.dataItems, 'position');
      setSelectedList(sortedItems);

      const updatedItems = _.clone(group.dataItems);
      if (updatedItems[key]) {
        updatedItems[key].selected = !updatedItems[key].selected;
      }
    });
  };

  /** Handles the selection of an item from Checker */
  const handleSelect = (e, item) => {
    const _selectedList = _.cloneDeep(selectedList);
    const itemToToggle = _.find(_selectedList, { value: item.value });
    if (itemToToggle) {
      itemToToggle.selected = !itemToToggle.selected;
    }
    // local
    setSelectedList(_selectedList)
  }

  /** Handles the selection of the `Select All` */
  const handleSelectAll = () => {
    const _selectedList = _.cloneDeep(selectedList);
    const toggleOn = !toggleSelectOn

    _.forEach(_selectedList, (item) => {
      item.selected = toggleOn
    })

    // local
    setSelectedList(_selectedList)
    setToggleSelectOn(toggleOn)
  }

  const handleCount = (item, count) => {
    const _selectedList = _.cloneDeep(selectedList);
    if (_selectedList[item.key]) { if (count) { _selectedList[item.key].count = count } }
    setSelectedList(_selectedList)
  }

  const labelCount = () => <Label color='blue'>{valueCount}</Label>
  const checkAll = () => <Checker item={{ key: 'checkAll' }} handleClick={handleSelectAll} checked={toggleSelectOn} label={'Select All'} size={'small'} ></Checker>

  const menuItem = (menuListItem) => {
    const { name, caption, text, key } = menuListItem ?? {}
    let itemCaption = name ? name : _.startCase(key)
    if (text) { itemCaption = text }
    if (caption) { itemCaption = caption }
    let checked = menuListItem.selected ? true : false

    return <Menu.Item key={key}>
      <Checker item={menuListItem} label={itemCaption} handleClick={handleSelect} handleCount={handleCount}
        checked={checked} useCounter={useCounter} itemProp={_itemProp} fip={_fip} />
    </Menu.Item>
  }

  const menuItems = (sell) => {
    const elements = []
    const _selectedList = sell ? sell : selectedList
    if (_selectedList) {
      _.forEach(_selectedList, (item, key) => {
        if (_.isObject(item)) {
          item.key = key
          elements.push(menuItem(item))
        }
      })
    }
    return elements
  }

  const menu = () => <Menu vertical fluid>
    {menuElements}
  </Menu>

  const dragMenu = () => {
    const _dndGroups = {
      sortedItems: {
        dataItems: selectedList,
        elements: menuItems()
      }
    }
    return <DragDropper
      ddType={'sortedItems'}
      dndType={dragDropperTypes.menuItemSelect}
      dndGroups={_dndGroups}
      handleSorted={handleSorted}
      groupChangeKey={'position'}
      allowSort={true}
      portalCn={'msmi menu-groups four menu'}
    />
  }

  const content = () => {
    if (allowSort) {
      return dragMenu()
    } else {
      return menuElements ? menu() : <div></div>
    }
  }

  return <Wrapper
    header={<div className={'menu-select-header'}>
      <div>{_.startCase(propname)}{labelCount()}</div>
      <div>{checkAll()}</div>
    </div>}
    content={selectedList && content()}
    wrapperType={wrapperTypes.padded}
    noMid={true}
  ></Wrapper>

  // return <div className={'menu-select-container adding mis'}>
  //   <div className={'menu-select-header'}>
  //     {_.startCase(propname)}{labelCount()}{checkAll()}
  //   </div>
  //   <div className={'menu-select-items'}>
  //     {selectedList && content()}
  //   </div>
  // </div>

}

export default MenuItemsSelect